import { httpV2 } from "@/api/index";

const Qs = require("qs");
/**
 * @summary Obtém as informações das configurações dos sinais de um diagnóstico.
 * @param {number} id - Id do sinal da tabela de diagnóstico.
 * @param {number} signalUnit - Unidade do sinal da tabela de diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetSignalSettingsStageTwo = function(id, signalUnit)
{
	const params = {};
	params.unit = signalUnit;
	
	return httpV2.get(`/GearboxStage2BrokenTeethSignals/${id}/Limits`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

/**
 * @summary Atualiza as configurações de um diagnóstico.
 * @param {number} monitoringElementId - Id de monitoração da turbina.
 * @param {object} diagnosticSettingModel - Modelo com as configurações novas.
 * @returns {promise} Promise da API.
 */
const UpdateDiagnosticSettingsStageTwo = async function(monitoringElementId = 0, diagnosticSettingModel)
{
	return httpV2.put(`/GearboxStage2BrokenTeethSignals/${monitoringElementId}`, diagnosticSettingModel);
};

/**
 * @summary Obtém as informações das configurações dos sinais de um diagnóstico.
 * @param {number} id - Id do sinal da tabela de diagnóstico.
 * @param {number} signalUnit - Unidade do sinal da tabela de diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetSignalSettingsStageThree = function(id, signalUnit)
{
	const params = {};
	params.unit = signalUnit;
	
	return httpV2.get(`/GearboxStage3BrokenTeethSignals/${id}/Limits`, {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

/**
 * @summary Atualiza as configurações de um diagnóstico.
 * @param {number} monitoringElementId - Id de monitoração da turbina.
 * @param {object} diagnosticSettingModel - Modelo com as configurações novas.
 * @returns {promise} Promise da API.
 */
const UpdateDiagnosticSettingsStageThree = async function(monitoringElementId = 0, diagnosticSettingModel)
{
	return httpV2.put(`/GearboxStage3BrokenTeethSignals/${monitoringElementId}`, diagnosticSettingModel);
};

export default {
	GetSignalSettingsStageTwo,
	UpdateDiagnosticSettingsStageTwo,
	GetSignalSettingsStageThree,
	UpdateDiagnosticSettingsStageThree
};
